import React from "react";
import { Box, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Header from "../../components/Header";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import axios from "axios";
import { gapi } from "gapi-script";
import { useState, useEffect } from "react";
import CustomAlert from "./CustomAlert";
import swal from "sweetalert";
import DeleteIcon from "@mui/icons-material/Delete";
import { useLocation, useNavigate } from "react-router-dom";

function Form() {
  const navigate = useNavigate();
  const location = useLocation();

  const fileConfiguarationDetail = location.state;

  const [alert, setAlert] = useState({ permission: false });
  const [formValues, setFormValues] = useState({
    fileId: "",
    fileName: "",
    fileLink: "",
  });

  const [tokenGatingInfo, setTokenGatingInfo] = useState([
    {
      blockchainNetwork: "",
      tokenStandard: "",
      permission: "",
      contractAddress: "",
      tokenId: "",
      nftRequired: "",
      tokenGatingType: "",
    },
  ]);

  const [edit, setEdit] = useState(false);

  function editForm() {
    if (fileConfiguarationDetail) {
      setFormValues({
        fileId: fileConfiguarationDetail.fileId,
        fileName: fileConfiguarationDetail.fileName,
      });
      setTokenGatingInfo(fileConfiguarationDetail.tokenGatingDetails);
      setEdit(true);
    }
  }

  const google = (window.google = window.google ? window.google : {});
  var API_KEY = null;
  var APP_ID = null;

  // Function runs when click on Select file button
  async function selectFile() {
    var access_token = null;
    await axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/access-token?appId=Google drive`,
        {
          headers: {
            "content-type": "application/json",
            token: localStorage.getItem("token"),
          },
        }
      )
      .then((response) => {
        let data = response.data;
        access_token = data.accessToken;
        API_KEY = data.apiKey;
        APP_ID = data.appId;
      });
    createPicker(access_token, API_KEY, APP_ID);
  }
  /**
   * Callback after api.js is loaded.
   */
  function gapiLoaded() {
    gapi.load("client:picker", intializePicker);
  }

  /**
   * Callback after the API client is loaded. Loads the
   * discovery doc to initialize the API.
   */
  async function intializePicker() {
    await gapi.client.load(
      "https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"
    );
  }

  function createPicker(accessToken, API_KEY, APP_ID) {
    const view = new google.picker.View(google.picker.ViewId.DOCS);
    const picker = new google.picker.PickerBuilder()
      .enableFeature(google.picker.Feature.MINE_ONLY)
      .setDeveloperKey(API_KEY)
      .setAppId(APP_ID)
      .setOAuthToken(accessToken)
      .addView(view)
      .addView(new google.picker.DocsUploadView())
      .setSize(600, 550)
      .setCallback((data) => pickerCallback(data))
      .build();
    picker.setVisible(true);
  }

  async function pickerCallback(data) {
    if (data.action === google.picker.Action.PICKED) {
      const document = data[google.picker.Response.DOCUMENTS][0];
      const fileId = document[google.picker.Document.ID];
      const fileName = document[google.picker.Document.NAME];
      const fileLink = document[google.picker.Document.URL];

      setFormValues((preValues) => {
        return {
          ...preValues,
          fileId: fileId,
          fileName: fileName,
          fileLink: fileLink,
        };
      });
    }
  }

  function handleTokenGatingInfo(i, e) {
    var { name, value } = e.target;
    let newTokenGatingInfo = [...tokenGatingInfo];

    if (name === "permission") {
      for (var j = 0; j < tokenGatingInfo.length; j++) {
        if (tokenGatingInfo[j].permission === value) {
          setAlert({ permission: true });
          value = "";
        }
      }
    }
    if (name === "tokenGatingType") {
      if (value === "tokenId") {
        newTokenGatingInfo[i]["nftRequired"] = "";
      } else {
        newTokenGatingInfo[i]["tokenId"] = "";
      }
    }
    newTokenGatingInfo[i][name] = value;
    setTokenGatingInfo(newTokenGatingInfo);
  }

  function handleAddClick() {
    setTokenGatingInfo([
      ...tokenGatingInfo,
      {
        blockchainNetwork: "",
        tokenStandard: "",
        permission: "",
        contractAddress: "",
        tokenId: "",
        nftRequired: "",
      },
    ]);
  }

  function removeFields(i, e) {
    let newTokenGatingInfo = [...tokenGatingInfo];
    newTokenGatingInfo.splice(i, 1);
    setTokenGatingInfo(newTokenGatingInfo);
  }

  function clearFirstField() {
    setTokenGatingInfo([
      {
        blockchainNetwork: "",
        tokenStandard: "",
        permission: "",
        contractAddress: "",
        tokenId: "",
        nftRequired: "",
      },
    ]);
  }

  function handleRefresh() {
    swal(
      "Are you sure!",
      "Configurations you made will not be saved.",
      "warning",
      {
        buttons: ["Cancel", "OK"],
      }
    ).then((value) => {
      if (value) {
        setFormValues({
          fileId: "",
          fileName: "",
          fileLink: "",
        });
        setTokenGatingInfo([
          {
            blockchainNetwork: "",
            tokenStandard: "",
            permission: "",
            contractAddress: "",
            tokenId: "",
            nftRequired: "",
          },
        ]);
      }
    });
  }
  async function submitForm(event) {
    event.preventDefault();
    await axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/google-drive/token-gated-file-info?appId=Google drive`,
        {
          formValues,
          tokenGatingInfo,
        },
        {
          headers: {
            "content-type": "application/json",
            token: localStorage.getItem("token"),
          },
        }
      )
      .then((response) => {
        if (response.data.status === true) {
          swal({
            title: "Success!",
            text: response.data.message,
            icon: "success",
            button: "OK",
          }).then(() => {
            navigate("/token-gating/google-drive");
          });
        } else if (response.data.status === false) {
          swal({
            title: response.data.message,
            icon: "warning",
            button: "OK",
          });
        }
      })
      .catch((err) => {
        swal({
          title: "Something Went Wrong!",
          icon: "error",
          button: "OK",
        });
      });
  }

  async function editSubmitForm(e) {
    e.preventDefault();
    await axios
      .put(
        `${process.env.REACT_APP_BASE_URL}/google-drive-file-info?appId=Google drive`,
        {
          formValues,
          tokenGatingInfo,
        },
        {
          headers: {
            "content-type": "application/json",
            token: localStorage.getItem("token"),
          },
        }
      )
      .then((response) => {
        if (response.data.status === true) {
          swal(
            "Edited!",
            `Your token gating configuration for file: ${formValues.fileName} is Edited.`,
            "success",
            {
              button: "OK",
            }
          ).then(() => {
            navigate("/token-gating/google-drive");
          });
        } else {
          swal("Something went wrong!", ``, "error", {
            button: "OK",
          });
        }
      })
      .catch((err) => {
        swal({
          text: err.response.data.errorMessage,
          icon: "error",
        });
      });
  }

  function handleShow() {
    setAlert({ permission: false });
  }

  useEffect(() => {
    gapiLoaded();
    editForm();
  }, []);

  return (
    <Box m="20px">
      <CustomAlert
        show={alert.permission}
        handleShow={handleShow}
        message="This permission is alerady selected"
      />
      <Box
        variant="gradient"
        borderRadius="lg"
        shadow="lg"
        opacity={1}
        p={3}
        textAlign="left"
        sx={{
          backgroundColor: "white",
          boxShadow: 4,
        }}
      >
        <Header title="Configure" />
        <form
          onSubmit={edit ? editSubmitForm : submitForm}
          style={{ width: "90%" }}
        >
          <div style={{ width: "49%" }}>
            <Typography className="google-drive-typography-text" mb={"5px"}>
              Please select the file you want to Token gate.
            </Typography>
            <Tooltip title="Select File" color="info">
              <Button
                className="custom-color-button"
                fullWidth
                onClick={() => selectFile()}
                color="info"
                sx={{
                  color: "white",
                  marginBottom: "20px",
                  height: "3.3rem",
                  fontSize: "1rem",
                }}
                variant="contained"
                disabled={edit}
                startIcon={<InsertDriveFileIcon />}
              >
                {formValues.fileName ? formValues.fileName : "Select File"}
              </Button>
            </Tooltip>
          </div>
          <Typography className="google-drive-typography-text" mb={"16px"}>
            Please provide permission you want to give your user's as well as
            NFT token gating details for user's to access the file.
          </Typography>
          {tokenGatingInfo.map((element, index) => (
            <div className="form-container" key={index}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "115%",
                    marginBottom: "12px",
                  }}
                >
                  <div
                    style={{
                      gap: "2%",
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                    }}
                  >
                    <fieldset className="login-form input-fullwidth">
                      <label
                        htmlFor="permission"
                        id="permissionLabel"
                        className="login-form-label"
                      >
                        Select Permission
                        <div className="input-div-css-1 input-div-css-2 input-fullwidth">
                          <div className="input-div-css-3">
                            <select
                              required
                              className="input-custom-css select-input"
                              id="permission"
                              aria-labelledby="permissionLabel"
                              name="permission"
                              onChange={(e) => handleTokenGatingInfo(index, e)}
                              value={element.permission}
                              aria-invalid="false"
                              defaultValue={""}
                            >
                              <option disabled value="">
                                Select Permission
                              </option>
                              <option value="Editor">Editor</option>
                              <option value="Commentor">Commentor</option>
                              <option value="Viewer">Viewer</option>
                            </select>
                          </div>
                        </div>
                      </label>
                    </fieldset>

                    <fieldset className="login-form input-fullwidth">
                      <label
                        htmlFor="blockchainNetwork"
                        id="blockchainNetworkLabel"
                        className="login-form-label"
                      >
                        Select BlockChain Network
                        <div className="input-div-css-1 input-div-css-2 input-fullwidth">
                          <div className="input-div-css-3">
                            <select
                              required
                              className="input-custom-css select-input"
                              id="blockchainNetwork"
                              aria-labelledby="blockchainNetworkLabel"
                              name="blockchainNetwork"
                              onChange={(e) => handleTokenGatingInfo(index, e)}
                              value={element.blockchainNetwork}
                              aria-invalid="false"
                              defaultValue={""}
                            >
                              <option disabled value="">
                                Select BlockChain Network
                              </option>
                              <option value="Ethereum">Ethereum</option>
                              <option value="Sepolia-Ethereum">
                                Sepolia Ethereum
                              </option>
                              <option value="Polygon">Polygon</option>{" "}
                              <option value="Base-Mainnet">Base Mainnet</option>
                            </select>
                          </div>
                        </div>
                      </label>
                    </fieldset>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "15%",
                    }}
                  >
                    <DeleteIcon
                      className="delete-icon"
                      onClick={(e) =>
                        tokenGatingInfo.length === 1
                          ? clearFirstField(e)
                          : removeFields(index, e)
                      }
                      fontSize="large"
                      sx={{
                        margin: "auto",
                        display: "none",
                        verticalAlign: "middle",
                      }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    marginBottom: "12px",
                    gap: "2%",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <fieldset className="login-form input-fullwidth">
                    <label
                      htmlFor="tokenStandard"
                      id="tokenStandardLabel"
                      className="login-form-label"
                    >
                      Select Token Standard
                      <div className="input-div-css-1 input-div-css-2 input-fullwidth">
                        <div className="input-div-css-3">
                          <select
                            required
                            className="input-custom-css select-input"
                            id="tokenStandard"
                            aria-labelledby="tokenStandardLabel"
                            name="tokenStandard"
                            onChange={(e) => handleTokenGatingInfo(index, e)}
                            value={element.tokenStandard}
                            aria-invalid="false"
                            defaultValue={""}
                          >
                            <option disabled value="">
                              Select Token Standard
                            </option>
                            <option value="ERC721">ERC-721</option>
                            <option value="ERC1155">ERC-1155</option>
                          </select>
                        </div>
                      </div>
                    </label>
                  </fieldset>

                  <fieldset className="login-form input-fullwidth">
                    <label
                      htmlFor="contractAddress"
                      id="contractAddressLabel"
                      className="login-form-label"
                    >
                      Contract Address
                      <div className="input-div-css-1 input-fullwidth input-div-css-2">
                        <div className="input-div-css-3">
                          <input
                            required
                            name="contractAddress"
                            aria-labelledby="contractAddressLabel"
                            type="text"
                            className="input-custom-css input-custom-height"
                            id="contractAddress"
                            aria-invalid="false"
                            value={element.contractAddress}
                            onChange={(e) => handleTokenGatingInfo(index, e)}
                          ></input>
                        </div>
                      </div>
                    </label>
                  </fieldset>
                </div>

                <div
                  style={{
                    gap: "2%",
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  {element.tokenStandard === "ERC721" && (
                    <fieldset
                      style={{
                        width: element.tokenGatingType ? "100%" : "49%",
                      }}
                      className="login-form"
                    >
                      <label
                        htmlFor="tokenGatingType"
                        id="tokenGatingTypeLabel"
                        className="login-form-label"
                      >
                        Select Token Gating Type
                        <div className="input-div-css-1 input-div-css-2 input-fullwidth">
                          <div className="input-div-css-3">
                            <select
                              required
                              className="input-custom-css select-input"
                              id="tokenGatingType"
                              aria-labelledby="tokenGatingTypeLabel"
                              name="tokenGatingType"
                              onChange={(e) => handleTokenGatingInfo(index, e)}
                              value={element.tokenGatingType}
                              aria-invalid="false"
                              defaultValue={""}
                            >
                              <option disabled value="">
                                Select Token Gating Type
                              </option>
                              <option value="tokenId">
                                On the basis of Token ID
                              </option>
                              <option value="numberOfNFT">
                                On the basis of number of NFT
                              </option>
                            </select>
                          </div>
                        </div>
                      </label>
                    </fieldset>
                  )}
                  {(element.tokenStandard === "ERC1155" ||
                    (element.tokenStandard === "ERC721" &&
                      element.tokenGatingType === "tokenId")) && (
                    <fieldset className="login-form input-fullwidth">
                      <label
                        htmlFor="tokenId"
                        id="tokenIdLabel"
                        className="login-form-label"
                      >
                        Token ID
                        <div className="input-div-css-1 input-fullwidth input-div-css-2">
                          <div className="input-div-css-3">
                            <input
                              required
                              name="tokenId"
                              aria-labelledby="tokenIdLabel"
                              type="text"
                              className="input-custom-css input-custom-height"
                              id="tokenId"
                              aria-invalid="false"
                              value={element.tokenId}
                              onChange={(e) => handleTokenGatingInfo(index, e)}
                            ></input>
                          </div>
                        </div>
                      </label>
                    </fieldset>
                  )}
                  {(element.tokenStandard === "ERC1155" ||
                    (element.tokenStandard === "ERC721" &&
                      element.tokenGatingType === "numberOfNFT")) && (
                    <fieldset className="login-form input-fullwidth">
                      <label
                        htmlFor="nftRequired"
                        id="nftRequiredLabel"
                        className="login-form-label"
                      >
                        Minimum NFT Required
                        <div className="input-div-css-1 input-fullwidth input-div-css-2">
                          <div className="input-div-css-3">
                            <input
                              required
                              name="nftRequired"
                              aria-labelledby="nftRequiredLabel"
                              type="number"
                              className="input-custom-css input-custom-height"
                              id="nftRequired"
                              aria-invalid="false"
                              min="1"
                              value={element.nftRequired}
                              onChange={(e) => handleTokenGatingInfo(index, e)}
                            ></input>
                          </div>
                        </div>
                      </label>
                    </fieldset>
                  )}
                </div>
              </div>
              {index !== tokenGatingInfo.length - 1 && (
                <hr
                  style={{
                    color: "#2e7c67",
                    marginTop: "20px",
                    marginBottom: "20px",
                    width: "111%",
                  }}
                />
              )}
            </div>
          ))}
          <div
            style={{
              marginTop: "22px",
              display: "flex",
            }}
          >
            <div style={{ marginRight: "auto" }}>
              <Button
                className="custom-color-button"
                variant="contained"
                sx={{
                  fontSize: "15px",
                }}
                startIcon={<AddIcon />}
                onClick={() => handleAddClick()}
                disabled={tokenGatingInfo.length >= 3 ? true : false}
              >
                ADD
              </Button>
            </div>
            <div style={{ display: "flex" }}>
              <Button
                className="custom-color-button"
                variant="contained"
                onClick={handleRefresh}
                disabled={edit}
                sx={{ fontSize: "15px" }}
              >
                Reset
              </Button>

              <Button
                className="custom-color-button"
                sx={{
                  marginLeft: "6%",
                  fontSize: "15px",
                }}
                type="submit"
                variant="contained"
                disabled={formValues.fileId ? false : true}
              >
                Submit
              </Button>
            </div>
          </div>
        </form>
      </Box>
    </Box>
  );
}

export default Form;
